import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import FileUpload from "./FileUpload";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <StrictMode>
    <FileUpload />
  </StrictMode>
);
